var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.ptCashVoucherGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.ptCashVoucherGetErrors = $event
          }
        }
      }),
      _c("v-data-table", {
        attrs: {
          items: _vm.ptCashVoucherList,
          headers: _vm.headers,
          page: _vm.page,
          itemsPerPage: _vm.itemsPerPage,
          "server-items-length": _vm.ptCashVoucherGetCount,
          loading: _vm.ptCashVoucherGetting,
          "single-expand": "",
          dense: ""
        },
        on: {
          "update:page": function($event) {
            _vm.page = $event
          },
          "update:itemsPerPage": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:items-per-page": function($event) {
            _vm.itemsPerPage = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item, isExpanded, expand }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary", "x-small": "" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("show", item.id)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-information-outline")])],
                        1
                      ),
                      _c("span", [_vm._v(_vm._s(item.pt_cash_voucher_number))])
                    ],
                    1
                  ),
                  _c("td", [_vm._v(_vm._s(item.pay_to))]),
                  _c("td", [_vm._v(_vm._s(item.date.dateFormat()))]),
                  _c("td", [_vm._v(_vm._s(item.requestor))]),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(_vm._s((item.amount || 0).phpFormat()))
                  ]),
                  _c("td", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(item.status ? item.status.description : null))
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      !item.approved_rejected_by && _vm.allowedForApproval
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "success",
                                text: "",
                                small: "",
                                dense: "",
                                loading: _vm.ptCashVoucherApprovePosting
                              },
                              on: {
                                click: function($event) {
                                  return _vm.approvePtCash(item.id)
                                }
                              }
                            },
                            [_c("span", [_vm._v("Approve")])]
                          )
                        : _vm._e(),
                      !item.approved_rejected_by && _vm.allowedForApproval
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "error",
                                text: "",
                                small: "",
                                dense: "",
                                loading: _vm.ptCashVoucherRejectPosting
                              },
                              on: {
                                click: function($event) {
                                  return _vm.rejectPtCash(item.id)
                                }
                              }
                            },
                            [_c("span", [_vm._v("Reject")])]
                          )
                        : _c(
                            "span",
                            { class: _vm.approvedRejectedColor(item.status) },
                            [
                              _vm._v(
                                _vm._s(
                                  item.approved_rejected_by
                                    ? item.approved_rejected_by.name
                                    : null
                                )
                              )
                            ]
                          )
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "v-icon",
                        {
                          class: !isExpanded || "is-expanded",
                          attrs: { color: "blue-grey darken-2" },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [_vm._v("mdi-chevron-down")]
                      ),
                      item.pt_cash_voucher_status_id !== "AP"
                        ? _c(
                            "v-icon",
                            {
                              attrs: { color: "yellow" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push(
                                    `/vouchers/${item.voucher_id}/petty-cash/${item.id}`
                                  )
                                }
                              }
                            },
                            [_vm._v("mdi-pencil")]
                          )
                        : _vm._e(),
                      item.pt_cash_voucher_status_id === "NW"
                        ? _c(
                            "v-icon",
                            {
                              attrs: { color: "red" },
                              on: {
                                click: function($event) {
                                  return _vm.printPdf(item.id)
                                }
                              }
                            },
                            [_vm._v("mdi-file")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: "9" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "9" } },
                            [
                              _c("v-simple-table", { attrs: { dense: "" } }, [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Account Code")]),
                                    _c("th", [_vm._v("Description")]),
                                    _c("th", { staticClass: "text-right" }, [
                                      _vm._v("Amount")
                                    ])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(item.details, function(detail) {
                                      return _c("tr", { key: detail.id }, [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              detail.account_code.account_code
                                            )
                                          )
                                        ]),
                                        _c("td", [
                                          _vm._v(_vm._s(detail.description))
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              _vm._s(detail.amount.phpFormat())
                                            )
                                          ]
                                        )
                                      ])
                                    }),
                                    _c("tr", [
                                      _c("th", { attrs: { colspan: "2" } }, [
                                        _vm._v("Total")
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm
                                              .totalAmount(item.details)
                                              .phpFormat()
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  2
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }